const getFirstLastName = name => name.split(/(\s).+\s/).join('');

export const abbreviattedName = name => {
  let formatted = getFirstLastName(name).split(' ');

  return formatted[0] + ' ' + formatted[1].charAt(0) + '.';
};

export default getFirstLastName;
